import ErrorBoundary from '@/components/ErrorBoundary';
import { CreateStepper } from '@/lib/Steppers';
import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { COMUNI_NEW_COMMUNICATION_STEPS_ITEM } from '../comuni-helper';
import { NewCommunicationProvider } from './context/NewCommunicationContext';
import { useNewCommunicationActions } from './context/useNewCommunicationActions';
import { useNewCommunicationValues } from './context/useNewCommunicationValues';
import { RecipientsStepContainer } from './RecipientsStepContainer';
import { SentSuccess } from './SentSuccess';
import { TopicStepContainer } from './TopicStepContainer';
import { ChannelStepContainer } from './ChannelStepContainer';
import { ChannelFlowsStep } from '../components/wizard/ChannelFlowsStep';
import { PreviewSendStep } from '../components/wizard/PreviewSendStep';

const stepTemplate = (currentStepId: string) => {
  switch (currentStepId) {
    case COMUNI_NEW_COMMUNICATION_STEPS_ITEM.RECIPIENTS:
      return <RecipientsStepContainer />;
    case COMUNI_NEW_COMMUNICATION_STEPS_ITEM.TOPIC:
      return <TopicStepContainer />;
    case COMUNI_NEW_COMMUNICATION_STEPS_ITEM.CHANNELS:
      return <ChannelStepContainer />;
    case COMUNI_NEW_COMMUNICATION_STEPS_ITEM.TEMPLATE:
      return <ChannelFlowsStep />;
    case COMUNI_NEW_COMMUNICATION_STEPS_ITEM.PREVIEW:
      return <PreviewSendStep />;
    default:
      return null;
  }
};

const NewCommunicationShell: FC = () => {
  const { t } = useTranslation('comuni');
  const history = useHistory();
  const { steps, currentStepId, currentStepIndex, sent, communicationName, channels } = useNewCommunicationValues();
  const { resetWizard } = useNewCommunicationActions();

  if (sent) {
    return <SentSuccess sent={sent} resetWizard={resetWizard} history={history} t={t} communicationName={communicationName} channels={channels} />;
  }

  return (
    <div className='grid w-full grid-cols-1 gap-6'>
      <CreateStepper steps={steps} currentStepIndex={currentStepIndex} className='w-full overflow-x-auto rounded-2xl border px-6 py-4' />
      <ErrorBoundary>{stepTemplate(currentStepId)}</ErrorBoundary>
    </div>
  );
};

export const NewCommunication: FC = () => (
  <NewCommunicationProvider>
    <NewCommunicationShell />
  </NewCommunicationProvider>
);
